import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { authHeaders, axiosInstance, isEmptyData } from '../../../utils/helper';
import { apiUrlB2B } from '../../../utils/constants';

const initialState = {
	isLoadingList: false,
	list: [],
	page: 1,
	totalPages: 0,
	total: 0,
	limit: 10,
};

export const getListArticle = createAsyncThunk('getListArticle', async ({ page = 1, limit = 10 }, { getState }) => {
	const company = getState().company;
	if (isEmptyData(company) || isEmptyData(company?.companyID))
		return {
			page: 1,
			limit: 10,
			total: 0,
			totalPage: 0,
			list: [],
		};
	const res = await axiosInstance.get(`${apiUrlB2B}menu-ufoodx?page=${page}&limit=${limit}&companyID=${company?.companyID}&type=ARTICLE`, authHeaders());
	return res?.data?.data;
});

const article = createSlice({
	name: 'article',
	initialState,
	reducers: {
		setArticle: (state, action) => {
			return { ...state, ...action.payload };
		},
		clearArticle: () => {
			return initialState;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getListArticle.pending, (state) => {
				state.isLoadingList = true;
			})
			.addCase(getListArticle.fulfilled, (state, action) => {
				state.isLoadingList = false;

				const payload = action.payload;

				if (!payload) return;

				const newList = payload.list || [];

				if (Number(payload.page) === 1) {
					state.list = newList;
				} else {
					state.list = [...(state.list || []), ...newList];
				}

				state.page = Number(payload.page);
				state.limit = Number(payload.limit);
				state.totalPages = Number(payload.totalPage);
				state.total = Number(payload.total);
			})
			.addCase(getListArticle.rejected, (state) => {
				state.isLoadingList = false;
			});
	},
});

export const { setArticle, clearArticle } = article.actions;
export default article.reducer;
